import styled from 'styled-components';

export const ShortTokenContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  color: black;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
`;

export const ShortTokenBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 20px;
`;

export const ShortTokenGenerateBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px;
  height: 90vh;
`;

export const VaultLogoWrapper = styled.div`
  margin-bottom: 60px;
`;

export const ButtonContainer = styled.div`
  margin: 20px 0;
`;

export const ShortTokenMainText = styled.p`
  color: black;
  margin: 5px 5px 0px 5px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  text-align: center;
  max-width: 300px;
  line-height: 30px;
`;

export const ShortTokenInstructions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const ShortTokenImage = styled.div`
  max-width: 250px;
  min-width: 250px;
`;

export const ShortTokenSurface = styled.div`
  display: flex;
  height: 300px;
  width: 300px;
  border-radius: 15px;
  flex-direction: column;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  margin: 20px;
  border: 4px solid
    ${(props) => props.theme.atlas.semantic.color.action.primary.default};
`;

export const ShortTokenHeading = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  font-size: 18px;
  margin: 20px;
  text-align: center;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
`;

export const CopyLink = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  font-size: 14px;
  &:hover {
    cursor: pointer;
  }
`;

export const ShortTokenText = styled.div`
  color: black;
  margin: 0 25px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  min-height: 70px;
  line-height: 24px;
  font-size: 14px;
  text-align: center;
`;

export const ShortTokenImages = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Header = styled.div`
  font-size: 36px;
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  margin-left: 10px;
  height: 100px;
  display: flex;
  align-items: center;
`;
